export const items = {
  leg_overwhelmingdesire: {
  },
  leg_odysseysend_p69: {
    stat: "dmgtaken",
    classes: ["demonhunter"],
  },
  /*leg_calamity: {
    buffs() {
      return {dmgtaken: 20};
    },
    classes: ["demonhunter"],
  },*/
  leg_strongarmbracers: {
    stat: "dmgtaken",
  },
  leg_oculusring: {
    stat: "damage",
  },
  leg_oculusring_p2: {
    stat: "dmgmul",
  },
  toxin: {
    buffs() {
      return {dmgtaken: 10};
    },
  },
  iceblink: {
    buffs() {
      return {chctaken: 10};
    },
  },
  leg_stainofsin: {
    tooltip: {
      id: "P72_Soulshard_004_3",
      stats: {custom: []},
    },
    buffs() {
      return {edmg: 150};
    },
  },
  leg_essenceofanguish: {
    tooltip: {
      id: "P72_Soulshard_005_3",
      stats: {essenceofanguish_2: []},
    },
    buffs() {
      return {dmgmul: {elems: ["psn"], percent: 50}};
    },
  },
  leg_remnantofpain: {
    tooltip: {
      id: "P72_Soulshard_007_3",
      stats: {remnantofpain_3: []},
    },
    params: [{min: 0, max: 10, name: "Stacks"}],
    buffs() {
      return {ias: this.params[0].val * 5};
    },
  },
  leg_dregsoflies: {
    tooltip: {
      id: "P72_Soulshard_006_3",
      stats: {dregsoflies_2: []},
    },
    buffs() {
      return {resall: 225};
    },
  },
};

export const followers = {
  templar_loyalty: {
    id: "Templar_Loyalty",
    buffs(stats) {
      return {regen: 6437};
    },
  },
  templar_inspire: {
    id: "Templar_Inspire",
    buffs(stats) {
      switch (stats.charClass) {
      case "wizard": return {apregen: 1.4};
      case "demonhunter": return {hatredregen: 1};
      case "witchdoctor": return {manaregen: 7};
      case "barbarian": return {resourcegen: 10};
      case "monk": return {resourcegen: 10};
      case "crusader": return {wrathregen: 1.1};
      // no default
      }
    },
  },
  scoundrel_hysteria: {
    id: "Scoundrel_Hysteria",
    buffs(stats) {
      return {damage: 3};
    },
  },
  scoundrel_anatomy: {
    id: "Scoundrel_Anatomy",
    buffs(stats) {
      return {chc: 1.8};
    },
  },
  enchantress_missileward: {
    id: "Enchantress_MissileWard",
    buffs(stats) {
      return {rangedef: 6};
    },
  },
  enchantress_poweredarmor: {
    id: "Enchantress_PoweredArmor",
    buffs(stats) {
      return {armor_percent: 3};
    },
  },
  enchantress_erosion: {
    id: "Enchantress_ScorchedEarth",
    buffs(stats) {
      return {dmgtaken: 3};
    },
  },
  enchantress_focusedmind: {
    id: "Enchantress_FocusedMind",
    buffs(stats) {
      return {ias: 3};
    },
  },
};

export const shrines = {
  shrine_blessed: {
    category: "Shrines",
    id: "shrine_blessed",
    buffs(stats) {
      return {dmgred: 25};
    },
  },
  shrine_empowered: {
    category: "Shrines",
    id: "shrine_empowered",
    buffs(stats) {
      return {cdr: 50, resourcegen: 100};
    },
  },
  shrine_enlightened: {
    category: "Shrines",
    id: "shrine_enlightened",
    buffs(stats) {
      return {expmul: 25};
    },
  },
  shrine_fleeting: {
    category: "Shrines",
    id: "shrine_fleeting",
    buffs(stats) {
      return {extrams: 25, pickup: 25};
    },
  },
  shrine_fortune: {
    category: "Shrines",
    id: "shrine_fortune",
    buffs(stats) {
      return {extrams: 25, pickup: 20};
    },
  },
  shrine_frenzied: {
    category: "Shrines",
    id: "shrine_frenzied",
    buffs(stats) {
      return {ias: 25};
    },
  },
  pylon_casting: {
    category: "Pylons",
    id: "pylon_casting",
    buffs(stats) {
      return {cdr: 75, rcr: 100};
    },
  },
  pylon_damage: {
    category: "Pylons",
    id: "pylon_damage",
    buffs(stats) {
      return {damage: 300};
    },
  },
  /*pylon_electrified: {
    category: "Pylons",
    id: "pylon_electrified",
    buffs(stats) {
    },
  },*/
  /*pylon_invulnerable: {
    category: "Pylons",
    id: "pylon_invulnerable",
    buffs(stats) {
      return {regen: 6437};
    },
  },*/
  pylon_running: {
    category: "Pylons",
    id: "pylon_running",
    buffs(stats) {
      return {extrams: 80, ias: 30};
    },
  },
};
